import { useMutation } from "@apollo/client";
import { VARIABLE_LISTS_ORDER_SET } from "graphql/mutation/variable-gql";
import { successNotification, errorNotification } from "components/request-result";
import { GET_VARIABLE_LISTS } from "graphql/query/variable-gql";

const useMutationVariableOrderSet = (variables: any) =>
{
    const [ _setVariableOrderSet, { loading } ] = useMutation(VARIABLE_LISTS_ORDER_SET,
        {
            update(cache, { data })
            {
                const {
                    variableListsOrderSet: {
                        label,
                        message,
                        variableLists
                    }
                } = data;

                const existing = cache.readQuery({
                    query: GET_VARIABLE_LISTS,
                    variables
                });

                let paginatorInfo = {
                    total: variableLists.length,
                    count: variableLists.length,
                    currentPage: 1,
                    perPage: variableLists.length,
                    lastPage: 1,
                    __typename: "PaginatorInfo"
                };
                if (existing && typeof existing === 'object' && 'variableLists' in existing && (existing as any).variableLists.paginatorInfo) {
                    paginatorInfo = (existing as any).variableLists.paginatorInfo;
                }

                cache.writeQuery({
                    query: GET_VARIABLE_LISTS,
                    variables,
                    data: {
                        variableLists: {
                            paginatorInfo,
                            data: variableLists,
                            __typename: "VariableListPaginator"
                        }
                    }
                });

                successNotification({
                    title: label,
                    description: message
                });
            },
            onError(error)
            {
                errorNotification(error);
            },
            // refetchQueries: [
            //     {
            //         query: GET_VARIABLE_LISTS,
            //         variables
            //     },
            // ],
        }
    );

    return {
        _setVariableOrderSet,
        loadingMutationVariableOrderSet: loading,
    };
};

export default useMutationVariableOrderSet;

